import { Injectable } from '@angular/core';
import { NavItemViewModel } from '../nav-item-view-model';
import { Router } from '@angular/router';
import { ProductGroupDomainModel } from '../../../../../../domainModels/product-group-domain-model';

@Injectable()
export class ProductsNavItemViewModel extends NavItemViewModel {
  constructor(
    private productGroupDomainModel: ProductGroupDomainModel,
    router: Router
  ) {
    super(router);
  }

  public readonly unassignedVariantCount$ = this.productGroupDomainModel.unassignedVariantCount$;
}
